module.exports = __webpack_public_path__ + "img/nt111-00-81-1.asm.78b86dce.jpg";